import React from 'react';
import { Button } from '@mui/material';

const OutlinedButton = ({ children, sx = {}, ...props }) => {
  return (
    <Button
      variant="outlined"
      size="small"
      sx={{
        color: "var(--id-color)",
        borderColor: "var(--id-color)",
        '&:hover': {
          backgroundColor: "var(--id-color)",
          color: "#fff",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default OutlinedButton;
